import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[open][drawerCustomPosition]',
})
export class DrawerCustomPositionDirective implements OnChanges {
  @Input() open!: boolean;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnChanges(): void {
    if (this.open) {
      const goaDrawerShadowRoot =
        this.el.nativeElement?.querySelector('goa-drawer')?.shadowRoot;
      if (!goaDrawerShadowRoot) return;

      const style = document.createElement('style');
      style.id = 'persistent-border-remover';
      style.textContent = `
    /* Target by class name */
    .header,
    .drawer-content,
    .drawer-actions,
    [class*="header"],
    [class*="drawer-content"],
    [class*="drawer-actions"] {
      border: none !important;
      border-bottom: none !important;
      box-shadow: none !important;
      background-image: none !important;
    }

    /* Target pseudo-elements more broadly */
    .header::before,
    .header::after,
    [class*="header"]::before,
    [class*="header"]::after {
      display: none !important;
      content: none !important;
      border: none !important;
      background: none !important;
      box-shadow: none !important;
    }
  `;
      goaDrawerShadowRoot.appendChild(style);

      // Also try targeting by data attributes or other stable selectors
      const headerElement = goaDrawerShadowRoot.querySelector(
        '.header, [data-testid*="header"], [class*="header"]'
      ) as HTMLElement;
      if (headerElement) {
        headerElement.style.setProperty('box-shadow', 'none', 'important');
        headerElement.style.setProperty(
          'background',
          'transparent',
          'important'
        );
        headerElement.style.setProperty(
          'background-image',
          'none',
          'important'
        );
      }
    }
    setTimeout(() => {
      this.applyHeaderBorderFix();
    }, 500);
  }

  applyHeaderBorderFix(): void {
    const goaDrawerShadowRoot =
      this.el.nativeElement?.querySelector('goa-drawer')?.shadowRoot;
    if (!goaDrawerShadowRoot) return;

    const headerElement = goaDrawerShadowRoot.querySelector(
      'goa-focus-trap > div > div > div[class*="header"]'
    ) as HTMLElement;
    if (!headerElement) return;

    headerElement.style.setProperty(
      'border-bottom',
      '1px solid var(--goa-color-greyscale-300, #707070)',
      'important'
    );
  }
}
